function closeCartDrawerAfterCheckout() {
  window.setTimeout(() => {
    const drawer = document.querySelector(
      'theme-drawer#cart-drawer'
    );

    const dialog = drawer?.querySelector('dialog[open]');

    if (!drawer || !dialog) return;

    if (typeof drawer.close === 'function') {
      drawer.close();
    } else {
      dialog.close();
    }
  }, 0);
}

document.addEventListener(
  'click',
  (event) => {
    const checkoutButton = event.composedPath().find(
      (element) =>
        element instanceof Element &&
        element.matches(
          'theme-drawer#cart-drawer button#checkout, ' +
          'theme-drawer#cart-drawer button[name="checkout"]'
        )
    );

    if (checkoutButton) {
      closeCartDrawerAfterCheckout();
    }
  },
  true
);